import { useState } from "react";

import iNext from "../../assets/images/100-circle-down.svg";
import iScreenOff from "../../assets/images/100-screen-off.svg";
import iScreenOn from "../../assets/images/100-screen-on.svg";
import avatar4 from "../../assets/images/avatar2.png";
import iOsApple from "../../assets/images/os-apple-black.svg";

const SingleScreen = ({ img, os, name, isMobile = false }) => {
  const [screenIsOn, setScreenIsOn] = useState(true);

  return (
    <section className={`single-screen ${isMobile && "mobile"}`}>
      <div className={`screen-main ${!screenIsOn && "screen-is-off"}`}>
        <div className="screen-power">
          <div className="tooltip tooltip-right" style={{ position: "relative" }}>
            Power On
          </div>
          <img
            alt=""
            src={!screenIsOn ? iScreenOn : iScreenOff}
            onClick={() => setScreenIsOn(!screenIsOn)}
            className="screen-power-icon"
            id="tooltip-a1"
          />
          <div className="fg-tooltip dark-mode right" id="tooltip-2">
            {screenIsOn ? "Force Shutdown" : "Power On"}
          </div>
        </div>
        <img alt="" src={img} className="screen-img" />
        <div className="only-show-in-mobile">
          <div className="next-screen-icon">
            <img alt="" src={iNext} className="i i-24 rotate-270 m-l-auto-half-24i" />
          </div>
        </div>
      </div>
      <div className={`screen-footer ${os}`}>
        <div className="align-center">
          <img alt="" src={iOsApple} className="flex m-r-6 i-16" />
          <span className="B3-SemiBold three-dot">{name}</span>
        </div>
        <div className="align-center">
          {screenIsOn ? (
            <>
              <div className="circle-users p-r-4">
                <img alt="" src={avatar4} className="i-20" />
                <img alt="" src={avatar4} className="i-20" />
                <img alt="" src={avatar4} className="i-20" />
              </div>
              <div className="C1-SemiBold align-center h-20">+12</div>
            </>
          ) : (
            <div className="B3-SemiBold fg-text-red">Screen is OFF</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SingleScreen;
